<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">消息详情</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <div class="contentTop">
                    <div class="icon">
                        <img src="../../assets/images/thstart.png" alt="">
                        <img src="../../assets/images/vipLogo.png" alt="">
                    </div>
                    <div>上领时光（上街店）</div>
                    <div><span>+200</span></div>
                    <div>交易成功</div>
                </div>
                <div class="line"></div>
                <div class="contentMain">
                    <div class="leftContent">
                        <span>付款方式</span>
                        <span>创建时间</span>
                        <span>完成时间</span>
                        <span>会员卡号</span>
                        <span>充值金额</span>
                        <span>充值赠送</span>
                        <span>原有余额</span>
                        <span>现有余额</span>
                    </div>
                    <div class="rightContent">
                        <span>现金</span>
                        <span>2018年8月8日  14:22</span>
                        <span>2018年8月8日  14:22</span>
                        <span>SLSG 1083 4791 656</span>
                        <span>¥200.00</span>
                        <span>¥5.00</span>
                        <span>¥0.00</span>
                        <span>¥205.00</span>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem } from 'mint-ui';
export default {
  data() {
    return {  
        isFront:false, 
        isVip:false,
        haveRead:false,
        selected:'1'   
    };
  },
  computed: {},
  components: {},
  methods: {     
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.minContent{
  background-color: #ffffff;  
}
.contentTop{
    width: 9.24rem;
    height: 3.74rem;
    margin-left: 0.39rem;
    position: relative;
}
.contentTop :nth-child(1){
    width: 1.84rem;
    height: 1.84rem;
    position: absolute;
    top: 0.39rem;
    left: 1rem;
}
.contentTop :nth-child(2){
    font-size: 0.37rem;
    position: absolute;
    top: 0.8rem;
    left: 3.45rem;
}
.contentTop :nth-child(3){
    font-size: 0.53rem;
    color: rgba(0, 0, 0, 0.9);
    text-align: center;
    position: absolute;
    top: 2rem;
    left: 3.45rem;
}
.contentTop :nth-child(3) :only-child{
    text-align: center;
    margin-top: -0.5rem;
    margin-left: -1.2rem;
}
.contentTop :nth-child(4){
    font-size: 0.26rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 3rem;
    left: 3.65rem;
}
.icon :nth-child(1){
    width: 0.89rem;
    height: 0.89rem;
    border-radius: 2.24rem;
    position: absolute;
}
.icon :nth-child(2){
    width: 0.26rem;
    height: 0.26rem;
    position: absolute;
    top: 1rem;
    left: 1.6rem;
}
.contentMain{
    height: 7.84rem;
    width: 100%;
}
.shopTitle{
    font-size: 0.42rem;
    color: rgba(0, 0, 0, 0.7);
    position: relative;
    top: 0.3rem;
    left: 3.03rem;
}
.leftContent{
    width: 50%;
    height: 100%;
    float: left;
    position: relative;
    top: -0.8rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.rightContent{
    width: 50%;
    height: 100%;
    float: right;
    position: relative;
    top: -0.8rem;
    right: 0rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
}
.leftContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    left: 0.53rem;
    color: rgba(0, 0, 0, 0.5);
}
.leftContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    left: 0.53rem;
    color: rgba(0, 0, 0, 0.5);
}
.leftContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    left: 0.53rem;
    color: rgba(0, 0, 0, 0.5);
}
.leftContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    left: 0.53rem;
}
.leftContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    left: 0.53rem;
}
.leftContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    left: 0.53rem;
}
.leftContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    left: 0.53rem;
}
.leftContent :nth-child(8){
    position: absolute;
    top: 6.65rem;
    left: 0.53rem;
}
.leftContent :nth-child(9){
    position: absolute;
    top: 7.38rem;
    left: 0.53rem;
}
.rightContent :nth-child(1){
    position: absolute;
    top: 1.29rem;
    right: 0.37rem;
}
.rightContent :nth-child(2){
    position: absolute;
    top: 2.05rem;
    right: 0.37rem;
}
.rightContent :nth-child(3){
    position: absolute;
    top: 2.82rem;
    right: 0.37rem;
}
.rightContent :nth-child(4){
    position: absolute;
    top: 3.61rem;
    right: 0.37rem;
}
.rightContent :nth-child(5){
    position: absolute;
    top: 4.37rem;
    right: 0.37rem;
    color: rgba(246, 34, 65, 1);
}
.rightContent :nth-child(6){
    position: absolute;
    top: 5.19rem;
    right: 0.37rem;
}
.rightContent :nth-child(7){
    position: absolute;
    top: 5.92rem;
    right: 0.37rem;
}
.rightContent :nth-child(8){
    position: absolute;
    top: 6.65rem;
    right: 0.37rem;
}
.rightContent :nth-child(9){
    position: absolute;
    top: 7.38rem;
    right: 0.37rem;
    color: rgba(246, 34, 65, 1);
}
.line{
    width: 95%;
    margin-left: 0.53rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    position: relative;
    top: 2.7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/messageDetails/chargeSuccessDetail.vue